module.exports = __webpack_public_path__ + "media/flags/in-47c9639e.svg";